import { useLazyQuery } from '@apollo/client';
import { exportXlsModal } from 'motion-components';
import { gqlGetQuery } from '../graphql';
import { buildWhereFromFilterValues } from './filters';
import { format, parseISO } from 'date-fns';

export const exportColumns = (t) => [
  { fieldName: 'id', fieldTitle: t('ID'), fieldType: 'TEXT' },
  { fieldName: 'qrCode', fieldTitle: t('QR Code'), fieldType: 'TEXT' },
  { fieldName: 'binSerialNo', fieldTitle: t('Αριθμός Κάδου'), fieldType: 'TEXT' },
  { fieldName: 'collectionpoint.name', fieldTitle: t('Σημείο Συλλογής'), fieldType: 'TEXT' },
  { fieldName: 'containertype.name', fieldTitle: t('Τύπος Συσκευασίας'), fieldType: 'TEXT' },
  { fieldName: 'declaredByUser', fieldTitle: t('Χρήστης Δήλωσης'), fieldType: 'TEXT' },
  { fieldName: 'declaredDate', fieldTitle: t('Ημ/νία Δήλωσης'), fieldType: 'DATE' },
  { fieldName: 'comments', fieldTitle: t('Σχόλια'), fieldType: 'TEXT' },
  { fieldName: 'isActive', fieldTitle: t('Ενεργό'), fieldType: 'TEXT' },
  { fieldName: 'firstRec', fieldTitle: t('Δήλωση'), fieldType: 'TEXT' },
  { fieldName: 'lastRec', fieldTitle: t('Αλλαγή'), fieldType: 'TEXT' },
];

export async function handleExport(client, queryState: any, t): Promise<void> {
  // this is the function expected by exportXlsModal
  function useGetQuery() {
    const [get, { loading, data }] = useLazyQuery(gqlGetQuery, {
      onCompleted: transformData,
    });
    return [get, { loading, data }];
  }

  function transformData(data) {
    const recs = data.getContainerQrcodes.data.map((values) => ({
      ...values,
      isActive: !values.isActive ? t('ΟΧΙ') : t('ΝΑΙ'),
      firstRec: `${
        values.firstDate ? format(parseISO(values.firstDate), 'dd/MM/yy HH:mm') : ''
      } - ${values.firstUser}`,
      lastRec: `${values.lastDate ? format(parseISO(values.lastDate), 'dd/MM/yy HH:mm') : ''} - ${
        values.lastUser
      }`,
    }));
    return {
      getContainerQrcodes: {
        data: recs,
        recordCount: data?.getContainerQrcodes?.recordCount,
      },
    };
  }

  const filterVariables = {
    where: buildWhereFromFilterValues(queryState?.filterValues),
  };

  await exportXlsModal({
    apolloClient: client,
    exportFileName: 'export_QrCodes',
    getLazyQuery: useGetQuery,
    columnsDef: exportColumns(t),
    filterVariables,
  });
}

